var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M254.7,493.5c131.8,0,238.8-107,238.8-238.8c0-131.8-107-238.8-238.8-238.8c-131.8,0-238.8,107-238.8,238.8 C15.9,386.5,122.9,493.5,254.7,493.5z M254.7,461.7c-114.2,0-207-92.7-207-207c0-114.2,92.7-207,207-207c114.2,0,207,92.7,207,207 C461.7,369,369,461.7,254.7,461.7z M232.2,254.7l-68.3,68.3c-6.2,6.2-6.2,16.3,0,22.5c6.2,6.2,16.3,6.2,22.5,0l68.3-68.3l68.3,68.3 c6.2,6.2,16.3,6.2,22.5,0c6.2-6.2,6.2-16.3,0-22.5l-68.3-68.3l68.3-68.3c6.2-6.2,6.2-16.3,0-22.5c-6.2-6.2-16.3-6.2-22.5,0 l-68.3,68.3l-68.3-68.3c-6.2-6.2-16.3-6.2-22.5,0c-6.2,6.2-6.2,16.3,0,22.5L232.2,254.7z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejected);
export default __webpack_public_path__ + "static/media/rejected.17c05042.svg";
export { ForwardRef as ReactComponent };